import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MdErrorOutline } from 'react-icons/md';
import { IoReloadOutline } from 'react-icons/io5';

interface ITasksErrorStateProps {
  onRetry: () => void;
}

const TasksErrorState = ({ onRetry }: ITasksErrorStateProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 3,
        minHeight: '300px',
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          width: '48px',
          height: '48px',
          borderRadius: '10px',
          border: '1px solid #FDECEA',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fff',
          boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
          mb: 2,
        }}
      >
        <MdErrorOutline size={24} color="#E74C3C" />
      </Box>

      {/* Text */}
      <Typography
        sx={{
          fontFamily: 'Tajawal, sans-serif',
          fontWeight: 800,
          fontSize: '16px',
          color: '#121926',
          textAlign: 'center',
          mb: 1,
        }}
      >
        {t('Automation.errorLoadingTasks')}
      </Typography>

      <Typography
        sx={{
          fontFamily: 'Tajawal, sans-serif',
          fontWeight: 400,
          fontSize: '14px',
          color: '#435363',
          textAlign: 'center',
          mb: 3,
        }}
      >
        {t('Automation.errorLoadingTasksDescription')}
      </Typography>

      {/* Retry Button */}
      <Button
        variant="contained"
        onClick={onRetry}
        startIcon={<IoReloadOutline />}
        sx={{
          backgroundColor: '#5B3FFF',
          borderRadius: '12px',
          fontFamily: 'Tajawal, sans-serif',
          fontSize: '14px',
          fontWeight: 700,
          textTransform: 'none',
          px: 4,
          py: 1.5,
          '&:hover': {
            backgroundColor: '#4930CC',
          },
        }}
      >
        {t('Automation.retry')}
      </Button>
    </Box>
  );
};

export default TasksErrorState;
